import React, { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';

const CustomDateInput = forwardRef(({ value, onClick }, ref) => {
  const { t } = useTranslation();
  
  return (
    <div
      className="d-flex align-items-center custom-date-input"
      onClick={onClick}
      ref={ref}
      style={{
        cursor: 'pointer',
        fontSize: 15,
        color: '#222',
        fontWeight: 400,
        minHeight: 38,
        height: 38,
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: 6,
        border: 'none',
        background: 'transparent',
        width: '100%'
      }}
    >
      <i className="bi bi-calendar3 me-2" style={{ fontSize: 14, color: '#9585c0' }}></i>
      <span style={{ fontSize: 14, color: value ? '#1a1033' : '#b4a8d0', fontWeight: value ? 500 : 400 }}>{value || t('seleccionar_fecha')}</span>
    </div>
  );
});

export default CustomDateInput;
